import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export const istpGuard: CanActivateFn = async (route, state) => {
    const authService: AuthService = inject(AuthService);
    const router: Router = inject(Router);
    const user = await firstValueFrom(
        authService.getUserInfoOrRefreshIfNeeded()
    );

    if (user.is_parent || user.is_teacher) {
        return true;
    } else {
        router.navigate(['homec']);
        return false;
    }
};
